import { interpolate } from '../../../global';
import { ILanguageResources, ITranslationModule } from '../../../interfaces';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeView.';
  public static readonly settingsTitle = `${Id.prefix}settingsTitle`;
}

export class LangFranchiseeView {
  private constructor() {}

  public static settingsTitle(): string {
    return interpolate(Id.settingsTitle);
  }
}

export class FranchiseeViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.settingsTitle, "{{glossary 'franchisee'}} Settings", 'Title for franchisee settings page');
  }
}
